module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/third-party.507bfe40.svg";